import axios from '../axios';

const fetchProjects = async () => {
  const { data } = await axios.get('/projects');

  return data;
};

export default fetchProjects;
